// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__AYcfj","contentWrapper":"styles_contentWrapper__iAJO_","categoryName":"styles_categoryName__0tr9p","title":"styles_title__l3piP","categorys":"styles_categorys__t__FP","divider":"styles_divider__4_2NP"};
module.exports.__checksum = "f95fc5e35a31"
